import { OpenPanel } from '@openpanel/web';

export type OpenPanelProperties = Record<string, unknown>;

const clientId = import.meta.env.VITE_OPENPANEL_CLIENT_ID as string | undefined;

const op = clientId
  ? new OpenPanel({
    clientId,
    apiUrl: import.meta.env.VITE_OPENPANEL_API_URL as string | undefined,
    trackScreenViews: false,
    trackAttributes: true,
    trackHashChanges: false,
  })
  : null;

export function track(event: string, properties?: OpenPanelProperties): void {
  op?.track(event, properties);
}

export function identify(args: {
  profileId: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  properties?: OpenPanelProperties;
}): void {
  op?.identify(args);
}

export function setGlobalProperties(properties: OpenPanelProperties): void {
  op?.setGlobalProperties(properties);
}

export function clear(): void {
  op?.clear();
}

